import { gql } from "apollo-boost";
import { sortLocationsByName } from "../../helpers/locations";
import useCurrentUserStore from "../../store/userStore";
import { apolloClient, getApolloOptions } from "./apolloClient";


const GET_USER_LOCATIONS = gql`
  query($limit: Int!, $offset: Int!, $userId: ID!) {
    locations(
      where:{users:{id: $userId}}
      limit: $limit
      start: $offset
      sort: "id:asc"
    ) {
      id
      name
      address
      zip_code
      place_name
      province
      country
      time_zone
      phone_number
      email
      public_booking_url
      disable_customer_mails
      latitude
      longitude
      xcubes {
        config
        id
        name
        letter
        type
        active
      }
    }
  }
`;

const GET_LOCATION_USERS = gql`
  query($id: ID!) {
    location(id: $id) {
      id
      users {
        id
        username
        email
        role {
          name
          type
        }
      }
    }
  }
`;

// Users linked to one location, used by Site information to list venue operators.
// Management users are linked to every location, so the view filters by role.
export const getLocationUsers = async (locationId) => {
    const res = await apolloClient.query({
        ...getApolloOptions(),
        query: GET_LOCATION_USERS,
        variables: { id: locationId },
    });
    return res.data.location?.users ?? [];
};

export const getUserLocationsSimple = async () => {
    const store = useCurrentUserStore();
    if (!store.currentUser) {
        return [];
    }
    const { id } = store.currentUser;
    let result = [];
    let offset = 0;
    let page = [];
    do {
        const res = await apolloClient.query({
            ...getApolloOptions(),
            query: GET_USER_LOCATIONS,
            variables: { limit: 100, offset: offset, userId: id },
        });
        page = res.data.locations;
        result = result.concat(page);
        offset += 100;
    } while (page.length === 100);
    return sortLocationsByName(result);
}
